import ReactECharts from 'echarts-for-react';
import {useState, useEffect} from "react";
import '../../../../cssfiles/homepage.css';
import { Typography } from '@mui/material';
import{ updatetheme,themedata }  from '../../../../store/theme_data';
import { useSelector, useDispatch } from "react-redux";
import { updatefilter } from '../../../../store/mainpage_data';
import CircularProgress from '@mui/material/CircularProgress';

const AssetMaintenanceDonutChartnewjson= (props) => {
    /*console.log("IN DONUTCHART I AM IN");
    console.log("IN donutCHART I AM IN");
    console.log("IN donutChart I AM IN");
    console.log("donutChart WIDGETNAME",props.widgetprop.widgetname)*/
    const [data1, setData1] = useState([0,0,0])
    const [datachart, setDataChart]= useState([]);   
    const theme = useSelector((state) => state.themedata.theme)
    const newdata = useSelector((state) => state.mainpagedata.updateddashboarddata)
    //const filter = useSelector((state) => state.mainpagedata.filter)
    const dispatch = useDispatch();
    const tagaliascollectionvaluesnewjson = useSelector((state) => state.mainpagedata.tagaliascollectionvaluesnewjson);
    const tagcollectionvaluesnewjson = useSelector((state) => state.mainpagedata.tagcollectionvaluesnewjson);
    
    //console.log("Donut inside new json mixed chart**********************AssetMaintenanceDonutChartnewjson********************",tagcollectionvaluesnewjson)
    const [donutdataoption,setDonutdataoption] = useState({})
    const [loading, setLoading] = useState(true);

    //var tag_properties = props.widgetprop.props.extended.tagprops;
    var color_properties_donuts = [];
    var width_properties_donuts = [];
    var curve_properties_donuts = [];
    var tagname_properties_donuts = [];
    const color_map = new Map();

    const[option,setOption]= useState({});  
    

    useEffect(() => {
        //const tag_properties = props.widgetprop.props.extended.tagprops;
        //console.log("Donut----------------------- inside mixed chart******asset main****************tagcollectionvaluesnewjson********************",tagcollectionvaluesnewjson["maintenanceconfig"]?.maintenanceObject)
        const color_map = new Map();
        const data = [];
        let sum = 0.0;

        var ranges = props.widgetprop.props.extended.ranges;
        var maintenance_config = tagcollectionvaluesnewjson["maintenanceconfig"]?.maintenanceObject;

        var maintenancejsondata = {};
        var maintenancejsonalias = {};
        for(var i=0;i<ranges.length;i++){
            var fromnumber = ranges[i].from
            var tonumber = ranges[i].to
            var chartprops = ranges[i].style_props

            var key = fromnumber+":"+tonumber;
            maintenancejsondata[key] = { chartprops: chartprops, count:0 };
            maintenancejsonalias[key] = ranges[i].category_name;

        }  

        for(var key in maintenance_config){
            var nextmaintenancedate = Number(maintenance_config[key]['Next Maintenance Date']);
            var currentdate = Math.floor(Date.now() / 1000);
            var diffInterval = 0;
            if((nextmaintenancedate != null) && (nextmaintenancedate != '')){
                diffInterval = ( Number(nextmaintenancedate) - Number(currentdate) ) / 86400;
           
                for(var i=0;i<ranges.length;i++){
                    var fromnumber = Number(ranges[i].from)
                    var tonumber = Number(ranges[i].to)
        
                    var key = fromnumber+":"+tonumber;
    
                    if(diffInterval >= fromnumber && diffInterval <= tonumber){
                        maintenancejsondata[key].count += 1;
                    }
        
                }  
            } 
        }

        for(var keydata in maintenancejsondata){

            var count = maintenancejsondata[keydata].count;
            data.push(Number.parseFloat(count).toFixed(2));
        }

        
        const donutchartbasedoptions = {
            title: {
                text: "",
                subtext: "",
                top: '110px',
                left: "90px",
                paddingTop: "13px",
                textStyle: {
                    fontSize: props.widgetprop.props.extended.textname.fontsize,
                    fontWeight: props.widgetprop.props.extended.textname.fontweight,
                    fontFamily: props.widgetprop.props.extended.textname.fontfamily,
                    align: "center",
                    color: (theme === 'light') ? "#3C3C3C" : "#FFFFFF",
                },
                subtextStyle: {
                    fontSize: props.widgetprop.props.extended.textvalue.fontsize,
                    fontWeight: props.widgetprop.props.extended.textvalue.fontweight,
                    fontFamily: props.widgetprop.props.extended.textvalue.fontfamily,
                    color: (theme === 'light') ? "#3C3C3C" : "#FFFFFF",
                    align: "center",
                },
            },
            series: [
                {
                    name: '',
                    type: 'pie',
                    radius: ['70%', '80%'],
                    itemStyle: {
                        borderColor: (theme === 'light') ? "#FFFFFF" : "#000000",
                        borderWidth: 3,
                    },
                    emphasis: {
                        scaleSize: 0
                    },
                    label: {
                        position: 'inside',
                        formatter: '{d}%',
                        color: (theme === 'light') ? "#000000" : "#FFFFFF",
                        fontSize: '10px',
                        fontWeight: 700,
                        fontFamily: "Roboto"
                    },
                    data: Object.keys(maintenancejsondata).map((key) => (
                        { value: Number(maintenancejsondata[key].count), name:  maintenancejsonalias[key] , itemStyle:  { color: (theme === 'light') ? maintenancejsondata[key].chartprops.color : maintenancejsondata[key].chartprops.color_dark }, label: { show: false } }     
                    ))
                    
                },
                {
                    name: '',
                    type: 'pie',
                    radius: [0, '70%'],
                    itemStyle: {
                        borderColor: (theme === 'light') ? "#FFFFFF" : "#000000",
                        borderWidth: 3,
                    },
                    emphasis: {
                        scaleSize: 0
                    },
                    label: {
                        position: 'inside',
                        formatter: '{c}',
                        color: "#FFFFFF"
                    },
                    data: Object.keys(maintenancejsondata).map((key) => (
                        { value: Number(maintenancejsondata[key].count), name: maintenancejsonalias[key]  , itemStyle: { color: (theme === 'light') ? maintenancejsondata[key].chartprops.color_inner_light : maintenancejsondata[key].chartprops.color_inner_dark }, label: { show: true, color: (theme === 'light') ? "#000000" : "#FFFFFF" } }
                    ))
                },
            ],
            legend: {
                left: '250px',
                top: '40px',
                borderColor: 'var(--PrimaryBackground)',
                paddingTop: 20,
                paddingLeft: 10,
                paddingRight: 2,
                itemGap: 30,
                itemStyle: {
                    color: 'inherit',
                    borderColor: '',
                    borderWidth: 0
                },
                textStyle: {
                    color: (theme === 'light') ? '#000000' : '#FFFFFF'
                },
                data: Object.keys(maintenancejsondata).map((key) => (
                    { value:  Number(maintenancejsondata[key].count), name: maintenancejsonalias[key] , itemStyle: { color: maintenancejsondata[key].chartprops.color }, label: { show: false }, }
                )).map((data_object) => (
                    { name: data_object.name, icon: 'circle' }
                )),
                z: 4,
                orient: 'vertical',
            },
            tooltip: {
                trigger: 'item',
                backgroundColor: '#005C8E',
                borderColor: '#000000',
                borderRadius: [0, 0, 0, 8],
                borderWidth: 0,
                renderMode: 'html',
                extraCssText: 'border-radius: 0 0 0 8px',
                textStyle: {
                    color: '#FFFFFF',
                    fontSize: 12,
                    height: 3,
                    fontFamily: "Roboto",
                    padding: 0
                },
                // formatter: function (params) {
                //     let stringconst;
                //     tag_properties.forEach(tagvalueprops => {
                //         console.log("tagvalueprops in DOUNUTCHART",tagvalueprops,"params",params)
                       
                //             if (params.data.name === tagaliascollectionvaluesnewjson[tagvalueprops.tagid]) {
                //                 stringconst = `<div style="display:flex; flex-direction:row "><div style="border-radius:10px; margin-top:4px; margin-right:5px; height:10px; width:10px; background-color:${color_map.get(tagvalueprops.tagid)}"></div>${params.data.name}:${params.data.value}</div>`;
                //             }
                        
                        
                //     });
                //     return stringconst;
                // }
            },
            grid: {
                left: -50,
                top: 30,
                containLabel: true
            },
            height: 250,
            width: 230
        };
        console.log("ASSET MSAIN TENANCE donutchartbasedoptions asset maintenance inside validation",donutchartbasedoptions)
        setOption(donutchartbasedoptions);
        setTimeout(()=>{
            setLoading(false);
        },1000);
        
    }, [props.widgetprop, theme, tagcollectionvaluesnewjson, tagaliascollectionvaluesnewjson]);

    /*
    useEffect(() => {
        //console.log("newdata ",newdata)
        
            if(props.widgetprop.widgetname=="Emission Evolution (tCO2e)"){
                var updatedata = {...donutoption_emissions}
                if(newdata.hasOwnProperty('emissionevolution')) {
                    var val = []
                    for(let i=0; i<newdata.emissionevolution.length; i++) {
                        for(let j=0; j<updatedata.series.length; j++) {
                            updatedata.series[j].data[i].value = newdata.emissionevolution[i].value
                        }
                        val.push(newdata.emissionevolution[i].value)
                    }
                    //console.log("val ",val)
                    setData1(val)
                    setOption(updatedata)
                }
            } else if(props.widgetprop.widgetname=="Asset Health") {
                var updatedata = {...donutoption_asset_health}
                if(newdata.hasOwnProperty('assethealth')) {
                    var val = []
                    for(let i=0; i<newdata.assethealth.length; i++) {
                        for(let j=0; j<updatedata.series.length; j++) {
                            updatedata.series[j].data[i].value = newdata.assethealth[i].value
                            val.push(newdata.assethealth[i].value)
                        }
                    }
                    //console.log("val ",val)
                    //setData1(val)
                    setOption(updatedata)
                }
            } else if(props.widgetprop.widgetname=="Shiftwise Consumption (kWh)") {
                var updatedata = {...donutoption_shiftwise_consumption}
                if(newdata.hasOwnProperty('shiftwiseconsumption')) {
                    var val = []
                    for(let i=0; i<newdata.shiftwiseconsumption.length; i++) {
                        for(let j=0; j<updatedata.series.length; j++) {
                            updatedata.series[j].data[i].value = newdata.shiftwiseconsumption[i].value
                            val.push(newdata.shiftwiseconsumption[i].value)
                        }
                    }
                    //console.log("val ",val)
                    //setData1(val)
                    setOption(updatedata)
                }
            } else if(props.widgetprop.widgetname=="PQ Events") {
                var updatedata = {...donutoption_pq}
                if(newdata.hasOwnProperty('pqevent')) {
                    var val = []
                    for(let i=0; i<newdata.pqevent.length; i++) {
                        for(let j=0; j<updatedata.series.length; j++) {
                            updatedata.series[j].data[i].value = newdata.pqevent[i].value
                            val.push(newdata.pqevent[i].value)
                        }
                    }
                    //console.log("val ",val)
                    //setData1(val)
                    setOption(updatedata)
                }
            } else if(props.widgetprop.widgetname=="Emission Evolution") {
                var updatedata = {...donutoption_emissions}
                if(newdata.hasOwnProperty('emissionevolution')) {
                    var val = []
                    for(let i=0; i<newdata.emissionevolution.length; i++) {
                        for(let j=0; j<updatedata.series.length; j++) {
                            updatedata.series[j].data[i].value = newdata.emissionevolution[i].value
                            val.push(newdata.emissionevolution[i].value)
                        }
                    }
                    //console.log("val ",val)
                    setData1(val)
                    setOption(updatedata)
                }
            } else if(props.widgetprop.widgetname=="Renewable vs Non-Renewable") {
                var updatedata = {...donutoption_renewable_consumption}
                if(newdata.hasOwnProperty('renewablenonrenewable')) {
                    var val = []
                    for(let i=0; i<newdata.renewablenonrenewable.length; i++) {
                        for(let j=0; j<updatedata.series.length; j++) {
                            updatedata.series[j].data[i].value = newdata.renewablenonrenewable[i].value
                        }
                        val.push(newdata.renewablenonrenewable[i].value)
                    }
                    //console.log("val ren ",val)
                    setData1(val)
                    setOption(updatedata)
                }
            } else if(props.widgetprop.widgetname=="Employee Diversity") {
                var updatedata = {...donutoption_employee_diversity}
                if(newdata.hasOwnProperty('employeediversity')) {
                    var val = []
                    for(let i=0; i<newdata.employeediversity.length; i++) {
                        for(let j=0; j<updatedata.series.length; j++) {
                            updatedata.series[j].data[i].value = newdata.employeediversity[i].value
                        }
                        val.push(newdata.employeediversity[i].value)
                    }
                    //console.log("val ren ",val)
                    setData1(val)
                    setOption(updatedata)
                }
            } else if(props.widgetprop.widgetname=="Human Rights Issues") {
                var updatedata = {...donutoption_human_rights}
                if(newdata.hasOwnProperty('humanrightsissues')) {
                    var val = []
                    for(let i=0; i<newdata.humanrightsissues.length; i++) {
                        for(let j=0; j<updatedata.series.length; j++) {
                            updatedata.series[j].data[i].value = newdata.humanrightsissues[i].value
                        }
                        val.push(newdata.humanrightsissues[i].value)
                    }
                    //console.log("val ren ",val)
                    setData1(val)
                    setOption(updatedata)
                }
            } else if(props.widgetprop.widgetname=="Customer Relations") {
                var updatedata = {...donutoption_customer_relations}
                if(newdata.hasOwnProperty('customerrelations')) {
                    var val = []
                    for(let i=0; i<newdata.customerrelations.length; i++) {
                        for(let j=0; j<updatedata.series.length; j++) {
                            updatedata.series[j].data[i].value = newdata.customerrelations[i].value
                        }
                        val.push(newdata.customerrelations[i].value)
                    }
                    //console.log("val ren ",val)
                    setData1(val)
                    setOption(updatedata)
                }
            } else if(props.widgetprop.widgetname=="Board Diversity") {
                var updatedata = {...donutoption_board_diversity}
                if(newdata.hasOwnProperty('boarddiversity')) {
                    var val = []
                    for(let i=0; i<newdata.boarddiversity.length; i++) {
                        for(let j=0; j<updatedata.series.length; j++) {
                            updatedata.series[j].data[i].value = newdata.boarddiversity[i].value
                        }
                        val.push(newdata.boarddiversity[i].value)
                    }
                    //console.log("val ren ",val)
                    setData1(val)
                    setOption(updatedata)
                }
            } else if(props.widgetprop.widgetname=="Asset Maintenance") {
                var updatedata = {...donutoption_asset_health}
                if(newdata.hasOwnProperty('assetmaintenance')) {
                    var val = []
                    for(let i=0; i<newdata.assetmaintenance.length; i++) {
                        for(let j=0; j<updatedata.series.length; j++) {
                            updatedata.series[j].data[i].value = newdata.assetmaintenance[i].value
                        }
                        val.push(newdata.assetmaintenance[i].value)
                    }
                    //console.log("val ren ",val)
                    setData1(val)
                    setOption(updatedata)
                }
            } else if(props.widgetprop.widgetname=="Assets Health Condition") {
                var updatedata = {...donutoption_asset_health_dashboard}
                if(newdata.hasOwnProperty('assetshelth')) {
                    var val = []
                    for(let i=0; i<newdata.assetshelth.length; i++) {
                        for(let j=0; j<updatedata.series.length; j++) {
                            updatedata.series[j].data[i].value = newdata.assetshelth[i].value
                        }
                        val.push(newdata.assetshelth[i].value)
                    }
                    //console.log("val ren ",val)
                    setData1(val)
                    setOption(updatedata)
                }
            }
    },[newdata])
    */
        
    /*
    const onChartReady = (chart) => {
        chart.on('legendselectchanged', function (params) {
            let sel = params.selected
            //console.log("sel ",)
            if (sel.Connected && sel.Disconnected) {
                dispatch(updatefilter('All'));
            } else if (sel.Connected && !sel.Disconnected) {
                dispatch(updatefilter('Disconnected'));
            } else if (!sel.Connected && sel.Disconnected) {
                dispatch(updatefilter('Connected'));
            } else if (!sel.Connected && !sel.Disconnected) {
                dispatch(updatefilter('None'));
            }
        })

    }
    */
    
    
        return(
            <>
                {/*<div style={{display:'inline-flex', flexDirection:'row', width:"100%", height:"100%"}}>
                         {props.widgetprop.widgetname == "Asset Status" ? <ReactECharts option={option} onChartReady={onChartReady} style={{ height: '95%', width: '140%', }} /> : <ReactECharts option={option} style={{ height: '95%', width: '140%', }} />}
                </div>*/}
                {/*console.log("donut option--options",option)*/}
                <div style={{display:'inline-flex', flexDirection:'row', width:"100%", height:"100%"}}>
                        {loading && <CircularProgress sx={{marginTop:"100px",marginLeft:"200px"}}/>}
                        {(!loading) && <ReactECharts option={option} style={{ height: '95%', width: '140%', }} />}
                </div>
            </>
        );
     
};

export default AssetMaintenanceDonutChartnewjson;